// FY27 region/broadcaster outputs from NHL's "INTL TV Playlists" list, named
// "Region (Broadcaster)" (Output.name is limited to 30 characters). They exist
// only for the TV and Radio playlists: every other playlist page, the Calendar
// feed list and the playlist export ignore them. Alphabetical on purpose; the TV
// and Radio feed list shows them in this order, after the DAZN feeds.
export const TVR_REGION_OUTPUT_NAMES = Object.freeze([
  'Africa (ESPN)',
  'Armenia (Vivaro)',
  'Australia (9GO)',
  'Australia (ESPN)',
  'Austria (SkySport)',
  'Balkans (Arena Sport)',
  'Belgium (ESPN)',
  'Bulgaria (Max Sports)',
  'China (CCTV)',
  'CIS (Quest Media)',
  'Cyprus (ESPN)',
  'Czech Republic (Nova Sport)',
  'Czech Republic (Prima)',
  'Denmark (TV3/Viaplay)',
  'Estonia (Go3)',
  'Finland (MTV3)',
  'Finland (Viaplay Group)',
  'France (beIN)',
  'Germany (Sky)',
  'Greece (ESPN)',
  'Hungary (Spiler)',
  'In-Flight / At-sea (Sport24)',
  'Israel (The Sports Channel)',
  'Latvia (TV6)',
  'Lithuania (Go3)',
  'Malta (ESPN)',
  'Mexico (Sky Mexico)',
  'Netherlands (ESPN)',
  'New Zealand (ESPN)',
  'Nordics (ESPN)',
  'Norway (Viaplay Group)',
  'Portugal (Sport TV)',
  'Romania (Antena Play)',
  'Slovakia (Markiza)',
  'Slovakia (Nova Sport)',
  'Slovakia (Prima)',
  'Spain (Movistar Plus)',
  'Sweden (Viaplay Group)',
  'Switzerland (TV24 / MySport)',
  'Switzerland (UPC / MySport)',
  'United Kingdom (ITV)',
  'United Kingdom (PremierSports)',
]);

const TVR_REGION_OUTPUT_NAME_SET = new Set(TVR_REGION_OUTPUT_NAMES);

export const isTvrRegionOutput = name => TVR_REGION_OUTPUT_NAME_SET.has(name);
